import { Link } from "react-router-dom"

import { batterySetupStepPath } from "./setup/setup-steps"

export const SELECT_LOAN_PRODUCT_LABEL = `Select Loan Product`

export function SelectLoanProductAction({
  proposalId,
}: {
  proposalId: string
}): JSX.Element {
  return (
    <div className="mt-7 print:hidden">
      <Link
        to={batterySetupStepPath(proposalId, `finance-product`)}
        data-testid="battery-financial-summary-select-loan-product"
        className="font-display inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-[length:var(--step-0)] font-bold text-bp-accent shadow-[0_12px_32px_rgba(0,0,0,0.25)] hover:bg-white/90 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
      >
        {SELECT_LOAN_PRODUCT_LABEL}
        <span aria-hidden="true">→</span>
      </Link>
    </div>
  )
}
